import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ico_close",
  "use": "icon-ico_close-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"icon-ico_close\"><defs><style>#icon-ico_close .cls-1{fill:none;}</style></defs><title></title><rect class=\"cls-1\" width=\"64\" height=\"64\" /><polygon points=\"53.36 49.53 35.33 31.5 53.36 13.47 50.53 10.64 32.5 28.67 14.47 10.64 11.64 13.47 29.67 31.5 11.64 49.53 14.47 52.36 32.5 34.33 50.53 52.36 53.36 49.53\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol